import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fieldsData: [],
};
export const commonSlice = createSlice({
  name: "commomSlice",
  initialState,
  reducers: {
    getAllFieldsData: (state, action) => {
      state.fieldsData = action.payload;
    },
  },
});

export const { getAllFieldsData } = commonSlice.actions;
export default commonSlice.reducer;
